import styled from 'styled-components';

export const Wrapper = styled.div`
  background-color: var(--t-brand-bg-color);
  color: var(--t-brand-fg-color);
  border-radius: var(--t-cards-border-radius);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.16);
  max-width: 90%;
  margin: 0 auto;

  @media (min-width: 768px) {
    max-width: 720px;
  }

  @media (min-width: 992px) {
    max-width: 760px;
  }
`;

export const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
`;

export const HeaderSection = styled.div`
  padding: 1.5rem;
  border-bottom: 1px solid var(--t-horizontal-vertical-rule);

  @media (min-width: 768px) {
    padding: 2rem;
  }
`;

export const ContentSection = styled.div<{ $scrolling: boolean }>`
  padding: 1.5rem;
  ${({ $scrolling }) =>
    $scrolling &&
    `
    max-height: 400px;
    overflow-y: auto;
  `}

  @media (min-width: 768px) {
    padding: 2rem;
  }
`;

export const FooterSection = styled.div`
  padding: 1.5rem;
  border-top: 1px solid var(--t-horizontal-vertical-rule);

  @media (min-width: 768px) {
    padding: 2rem;
  }
`;